// ACTIONS project
export const GEOIP_URL = '/p/ip.pl';
export const STATIC_DOMAIN = 'https://www.eyespy360.com/';
export const DISTANCE_FOR_MOVE = 20;
export const DISTANCE_FOR_MOVE_HOLE = 0.05;
export const THICKNESS = 150;
export const OPACITY_INTERNAL_WALLS = 1;
export const OPACITY_EXTRENAL_WALLS = 0.1;
export const SCALE_FACE = 0.000000000001;
export const RESOLUTION_SCALE_HIGH = 0.4;
export const RESOLUTION_SCALE_LOW = 0.3;
export const COUNT_SNAP_DISSEMBLE = 400;
export const FONT_SIZE = 30;
export const FONT_SIZE_MEAUREMENT = 20;
export const FONT_SIZE_ASPECT = FONT_SIZE_MEAUREMENT / FONT_SIZE;
export const FONT_FAMILY = {
    ARIAL_BOLD: '"Arial Bold", serif',
    ARIAL: 'Arial, serif',
};
export const LABEL_STYLES = {
    labelShadow: {
        fontFamily: FONT_FAMILY.ARIAL_BOLD,
        fontSize: FONT_SIZE,
        fontWeight: 900,
        letterSpacing: 0,
    },
    measurementShadow: {
        fontFamily: FONT_FAMILY.ARIAL,
        fontSize: FONT_SIZE_MEAUREMENT,
        fontWeight: 900,
        letterSpacing: 1,
    }
}
export const STYLE_TEXT = {
    textAnchor: 'middle',
    fontFamily: FONT_FAMILY.ARIAL_BOLD,
    fontSize: `${FONT_SIZE}px`,
    pointerEvents: 'none',
    fontWeight: 'bold',

    //http://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting-using-css
    WebkitTouchCallout: 'none', /* iOS Safari */
    WebkitUserSelect: 'none', /* Chrome/Safari/Opera */
    MozUserSelect: 'none', /* Firefox */
    MsUserSelect: 'none', /* Internet Explorer/Edge */
    userSelect: 'none'
};
export const DISCLAIMER = 'Floor plans are intended to give a general indication of the proposed layout only. All images and dimensions are not intended to form part any contract or warranty';
export const NEW_PROJECT = 'NEW_PROJECT';
export const LOAD_PROJECT = 'LOAD_PROJECT';
export const SAVE_PROJECT = 'SAVE_PROJECT';
export const OPEN_CATALOG = 'OPEN_CATALOG';
export const SELECT_TOOL_EDIT = 'SELECT_TOOL_EDIT';
export const UNSELECT_ALL = 'UNSELECT_ALL';
export const SET_PROPERTIES = 'SET_PROPERTIES';
export const SET_ITEMS_ATTRIBUTES = 'SET_ITEMS_ATTRIBUTES';
export const SET_LINES_ATTRIBUTES = 'SET_LINES_ATTRIBUTES';
export const SET_HOLES_ATTRIBUTES = 'SET_HOLES_ATTRIBUTES';
export const REMOVE = 'REMOVE';
export const ROTATE = 'ROTATE';
export const BEGIN_ROTATING_AREA = 'BEGIN_ROTATING_AREA';
export const UPDATE_ROTATING_AREA = 'UPDATE_ROTATING_AREA';
export const END_ROTATING_AREA = 'END_ROTATING_AREA';
export const UNDO = 'UNDO';
export const ROLLBACK = 'ROLLBACK';
export const SET_PROJECT_PROPERTIES = 'SET_PROJECT_PROPERTIES';
export const OPEN_PROJECT_CONFIGURATOR = 'OPEN_PROJECT_CONFIGURATOR';
export const INIT_CATALOG = 'INIT_CATALOG';
export const UPDATE_MOUSE_COORDS = 'UPDATE_MOUSE_COORDS';
export const UPDATE_ZOOM_SCALE = 'UPDATE_ZOOM_SCALE';
export const TOGGLE_SNAP = 'TOGGLE_SNAP';
export const CHANGE_CATALOG_PAGE = 'CHANGE_CATALOG_PAGE';
export const GO_BACK_TO_CATALOG_PAGE = 'GO_BACK_TO_CATALOG_PAGE';
export const THROW_ERROR = 'THROW_ERROR';
export const THROW_WARNING = 'THROW_WARNING';
export const COPY_PROPERTIES = 'COPY_PROPERTIES';
export const PASTE_PROPERTIES = 'PASTE_PROPERTIES';
export const PUSH_LAST_SELECTED_CATALOG_ELEMENT_TO_HISTORY = 'PUSH_LAST_SELECTED_CATALOG_ELEMENT_TO_HISTORY';
export const OPEN_LAYER_MANAGER = 'OPEN_LAYER_MANAGER';
export const SET_READ_ONLY_MODE = 'SET_READ_ONLY_MODE';
export const SET_IDLE_MODE = 'SET_IDLE_MODE';
export const SET_MANAGING_LAYERS_MODE = 'SET_MANAGING_LAYERS_MODE';
export const CHECK_SIZE_OF_CANVAS = 'CHECK_SIZE_OF_CANVAS';
export const SET_CUSTOM_UPDATE = 'SET_CUSTOM_UPDATE';

// METRIC TYPE
export const AREA = 'AREA';
export const LENGTH = 'LENGTH';

// ACTIONS viewer2D
export const SELECT_TOOL_ZOOM_IN = 'SELECT_TOOL_ZOOM_IN';
export const SELECT_TOOL_ZOOM_OUT = 'SELECT_TOOL_ZOOM_OUT';
export const SELECT_TOOL_PAN = 'SELECT_TOOL_PAN';
export const SELECT_TOOL_PAN_READ_ONLY = 'SELECT_TOOL_PAN_READ_ONLY';
export const SELECT_TOOL_PAN_SCREENSHOT = 'SELECT_TOOL_PAN_SCREENSHOT';
export const UPDATE_2D_CAMERA = 'UPDATE_2D_CAMERA';

//ACTIONS viewer3D
export const SELECT_TOOL_3D_VIEW = 'SELECT_TOOL_3D_VIEW';
export const SELECT_TOOL_3D_FIRST_PERSON = 'SELECT_TOOL_3D_FIRST_PERSON';
export const SELECT_TOOL_2D_FLOORPLANS_VIEW = 'SELECT_TOOL_2D_FLOORPLANS_VIEW';

//ACTIONS viewer3D read only
export const SELECT_TOOL_3D_VIEW_READ_ONLY = 'SELECT_TOOL_3D_VIEW_READ_ONLY';
export const SELECT_TOOL_3D_FIRST_PERSON_READ_ONLY = 'SELECT_TOOL_3D_FIRST_PERSON_READ_ONLY';
export const SELECT_TOOL_3D_SCREENSHOT = 'SELECT_TOOL_3D_SCREENSHOT';

//ACTIONS items
export const SELECT_TOOL_DRAWING_ITEM = 'SELECT_TOOL_DRAWING_ITEM';
export const UPDATE_DRAWING_ITEM = 'UPDATE_DRAWING_ITEM';
export const END_DRAWING_ITEM = 'END_DRAWING_ITEM';
export const BEGIN_DRAGGING_ITEM = 'BEGIN_DRAGGING_ITEM';
export const UPDATE_DRAGGING_ITEM = 'UPDATE_DRAGGING_ITEM';
export const UPDATE_DRAGGING_AREA = 'UPDATE_DRAGGING_AREA';
export const END_DRAGGING_ITEM = 'END_DRAGGING_ITEM';
export const BEGIN_ROTATING_ITEM = 'BEGIN_ROTATING_ITEM';
export const UPDATE_ROTATING_ITEM = 'UPDATE_ROTATING_ITEM';
export const END_ROTATING_ITEM = 'END_ROTATING_ITEM';
export const BEGIN_SCALING_ITEM = 'BEGIN_SCALING_ITEM';
export const END_SCALING_ITEM = 'END_SCALING_ITEM';
export const UPDATE_SCALING_ITEM = 'UPDATE_SCALING_ITEM';

//ACTION drawings
export const SELECT_HOLE = 'SELECT_HOLE';
export const SELECT_AREA = 'SELECT_AREA';
export const PUT_MERGE_AREAS = 'PUT_MERGE_AREAS';
export const MERGE_AREAS = 'MERGE_AREAS';
export const SELECT_AREAS = 'SELECT_AREAS';
export const SELECT_ITEM = 'SELECT_ITEM';
export const SELECT_LINE = 'SELECT_LINE';
export const SELECT_TOOL_DRAWING_LINE = 'SELECT_TOOL_DRAWING_LINE';
export const BEGIN_DRAWING_LINE = 'BEGIN_DRAWING_LINE';
export const UPDATE_DRAWING_LINE = 'UPDATE_DRAWING_LINE';
export const END_DRAWING_LINE = 'END_DRAWING_LINE';
export const SELECT_TOOL_DRAWING_HOLE = 'SELECT_TOOL_DRAWING_HOLE';
export const UPDATE_DRAWING_HOLE = 'UPDATE_DRAWING_HOLE';
export const END_DRAWING_HOLE = 'END_DRAWING_HOLE';
export const BEGIN_DRAGGING_LINE = 'BEGIN_DRAGGING_LINE';
export const UPDATE_DRAGGING_LINE = 'UPDATE_DRAGGING_LINE';
export const REMOVE_MERGE_AREAS = 'REMOVE_MERGE_AREAS';
export const END_DRAGGING_LINE = 'END_DRAGGING_LINE';
export const UPDATE_INVERT_FIELD = 'UPDATE_INVERT_FIELD';
export const SELECT_TOOL_UPLOAD_IMAGE = 'SELECT_TOOL_UPLOAD_IMAGE';
export const BEGIN_UPLOADING_IMAGE = 'BEGIN_UPLOADING_IMAGE';
export const END_UPLOADING_IMAGE = 'END_UPLOADING_IMAGE';
export const BEGIN_FITTING_IMAGE = 'BEGIN_FITTING_IMAGE';
export const END_FITTING_IMAGE = 'END_FITTING_IMAGE';
export const BEGIN_DRAGGING_HOLE = 'BEGIN_DRAGGING_HOLE';
export const UPDATE_DRAGGING_HOLE = 'UPDATE_DRAGGING_HOLE';
export const MOVE_HOLE = 'MOVE_HOLE';
export const END_DRAGGING_HOLE = 'END_DRAGGING_HOLE';

//ACTIONS vertices
export const BEGIN_DRAGGING_VERTEX = 'BEGIN_DRAGGING_VERTEX';
export const UPDATE_DRAGGING_VERTEX = 'UPDATE_DRAGGING_VERTEX';
export const END_DRAGGING_VERTEX = 'END_DRAGGING_VERTEX';
export const TOOGLE_VERTEX = 'TOOGLE_VERTEX';

//ACTIONS scene
export const SET_LAYER_PROPERTIES = 'SET_LAYER_PROPERTIES';
export const ADD_LAYER = 'ADD_LAYER';
export const SELECT_LAYER = 'SELECT_LAYER';
export const ADD_LOADING = 'ADD_LOADING';
export const REMOVE_LOADING = 'REMOVE_LOADING';
export const REMOVE_LAYER = 'REMOVE_LAYER';
export const SET_UNIT = 'SET_UNIT';
export const SET_METRICAL = 'SET_METRICAL';
export const HIDE_MEASUREMENT = 'HIDE_MEASUREMENT';

//ACTIONS catalog
export const CHANGE_CATALOG_CATEGORY = 'CHANGE_CATALOG_CATEGORY';

//ACTIONS area
export const MOVE_AREA = 'MOVE_AREA';
export const BEGIN_DRAGGING_AREA = 'BEGIN_DRAGGING_AREA';
export const END_DRAGGING_AREA = 'END_DRAGGING_AREA';
export const BEGIN_SCALE_AREA = 'BEGIN_SCALE_AREA';
export const MODE_SCALING_AREA = 'MODE_SCALING_AREA';
export const UPDATE_SCALING_AREA = 'UPDATE_SCALING_AREA';
export const BEGIN_SCALING_AREA = 'BEGIN_SCALING_AREA';
export const END_SCALING_AREA = 'END_SCALING_AREA';
export const BEGIN_SCALING_AREA_VERTEX = 'BEGIN_SCALING_AREA_VERTEX';

//ACTIONS messages
export const COMPONENT_READY = 'COMPONENT_READY';
export const COMPONENT_WAIT_CONFIG = 'COMPONENT_WAIT_CONFIG';
export const COMPONENT_SAVE = 'COMPONENT_SAVE';
export const COMPONENT_WAS_SAVED = 'COMPONENT_WAS_SAVED';
export const COMPONENT_EXIT = 'COMPONENT_EXIT';

//ACTIONS modal
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

//ACTIONS layer
export const BEGIN_ROTATING_LAYER = 'BEGIN_ROTATING_LAYER';
export const UPDATE_ROTATING_LAYER = 'UPDATE_ROTATING_LAYER';
export const END_ROTATING_LAYER = 'END_ROTATING_LAYER';
export const SET_LAYER_ANGLE = 'SET_LAYER_ANGLE';
export const SET_LAYER_CENTER = 'SET_LAYER_CENTER';
export const BEGIN_DRAGGING_LAYER = 'BEGIN_DRAGGING_LAYER';
export const UPDATE_DRAGGING_LAYER = 'UPDATE_DRAGGING_LAYER';
export const END_DRAGGING_LAYER = 'END_DRAGGING_LAYER';
export const APPLY_TO_ALL_ROOM = 'APPLY_TO_ALL_ROOM';
export const CHANGE_FONT_SIZE = 'CHANGE_FONT_SIZE';

//GROUPING ACTIONS
export const PROJECT_ACTIONS = {
  NEW_PROJECT,
  LOAD_PROJECT,
  SAVE_PROJECT,
  OPEN_CATALOG,
  SELECT_TOOL_EDIT,
  UNSELECT_ALL,
  SET_PROPERTIES,
  SET_ITEMS_ATTRIBUTES,
  SET_LINES_ATTRIBUTES,
  SET_HOLES_ATTRIBUTES,
  REMOVE,
  UNDO,
  ROLLBACK,
  SET_PROJECT_PROPERTIES,
  OPEN_PROJECT_CONFIGURATOR,
  INIT_CATALOG,
  UPDATE_MOUSE_COORDS,
  UPDATE_ZOOM_SCALE,
  TOGGLE_SNAP,
  CHANGE_CATALOG_PAGE,
  GO_BACK_TO_CATALOG_PAGE,
  THROW_ERROR,
  THROW_WARNING,
  COPY_PROPERTIES,
  PASTE_PROPERTIES,
  PUSH_LAST_SELECTED_CATALOG_ELEMENT_TO_HISTORY,
  OPEN_LAYER_MANAGER,
  SET_READ_ONLY_MODE,
  SET_IDLE_MODE,
  SET_MANAGING_LAYERS_MODE,
  CHECK_SIZE_OF_CANVAS,
  SET_CUSTOM_UPDATE,
};

export const VIEWER2D_ACTIONS = {
  SELECT_TOOL_ZOOM_IN,
  SELECT_TOOL_ZOOM_OUT,
  SELECT_TOOL_PAN,
  SELECT_TOOL_PAN_READ_ONLY,
  SELECT_TOOL_PAN_SCREENSHOT,
  UPDATE_2D_CAMERA,
  SELECT_TOOL_2D_FLOORPLANS_VIEW,
};

export const VIEWER3D_ACTIONS = {
  SELECT_TOOL_3D_VIEW,
  SELECT_TOOL_3D_FIRST_PERSON,
  SELECT_TOOL_3D_VIEW_READ_ONLY,
  SELECT_TOOL_3D_FIRST_PERSON_READ_ONLY,
  SELECT_TOOL_3D_SCREENSHOT
};

export const ITEMS_ACTIONS = {
  SELECT_ITEM,
  SELECT_TOOL_DRAWING_ITEM,
  UPDATE_DRAWING_ITEM,
  END_DRAWING_ITEM,
  BEGIN_DRAGGING_ITEM,
  UPDATE_DRAGGING_ITEM,
  END_DRAGGING_ITEM,
  BEGIN_ROTATING_ITEM,
  UPDATE_ROTATING_ITEM,
  END_ROTATING_ITEM,
  BEGIN_SCALING_ITEM,
  END_SCALING_ITEM,
  UPDATE_SCALING_ITEM
};

export const HOLE_ACTIONS = {
  SELECT_HOLE,
  SELECT_TOOL_DRAWING_HOLE,
  UPDATE_DRAWING_HOLE,
  END_DRAWING_HOLE,
  BEGIN_DRAGGING_HOLE,
  UPDATE_DRAGGING_HOLE,
  MOVE_HOLE,
  END_DRAGGING_HOLE
};

export const LINE_ACTIONS = {
  SELECT_LINE,
  SELECT_TOOL_DRAWING_LINE,
  BEGIN_DRAWING_LINE,
  UPDATE_DRAWING_LINE,
  END_DRAWING_LINE,
  BEGIN_DRAGGING_LINE,
  UPDATE_DRAGGING_LINE,
  END_DRAGGING_LINE,
  UPDATE_INVERT_FIELD
};

export const AREA_ACTIONS = {
  SELECT_AREA,
  BEGIN_DRAGGING_AREA,
  UPDATE_DRAGGING_AREA,
  END_DRAGGING_AREA,
  BEGIN_SCALING_AREA ,
  END_SCALING_AREA ,
  MODE_SCALING_AREA,
  REMOVE_MERGE_AREAS,
  UPDATE_SCALING_AREA,
  BEGIN_SCALING_AREA_VERTEX,
  SELECT_AREAS,
  PUT_MERGE_AREAS,
  MERGE_AREAS,
  ROTATE,
  BEGIN_ROTATING_AREA,
  UPDATE_ROTATING_AREA,
  END_ROTATING_AREA,
  MOVE_AREA,
};

export const SCENE_ACTIONS = {
  ADD_LAYER,
  SET_LAYER_PROPERTIES,
  SELECT_LAYER,
  ADD_LOADING,
  REMOVE_LOADING,
  REMOVE_LAYER,
  SET_UNIT,
  SET_METRICAL,
  HIDE_MEASUREMENT
};

export const VERTEX_ACTIONS = {
  BEGIN_DRAGGING_VERTEX,
  UPDATE_DRAGGING_VERTEX,
  END_DRAGGING_VERTEX,
  TOOGLE_VERTEX
};

export const CATALOG_ACTIONS = {
  CHANGE_CATALOG_CATEGORY
};

export const MESSAGE_ACTIONS = {
  COMPONENT_READY,
  COMPONENT_WAIT_CONFIG,
  COMPONENT_SAVE,
  COMPONENT_WAS_SAVED,
  COMPONENT_EXIT
};

export const MODAL_ACTIONS = {
  SHOW_MODAL,
  HIDE_MODAL
};

export const LAYER_ACTIONS = {
  BEGIN_ROTATING_LAYER,
  UPDATE_ROTATING_LAYER,
  END_ROTATING_LAYER,
  SET_LAYER_ANGLE,
  SET_LAYER_CENTER,
  BEGIN_DRAGGING_LAYER,
  UPDATE_DRAGGING_LAYER,
  END_DRAGGING_LAYER,
  CHANGE_FONT_SIZE,
};

//MODES
export const MODE_IDLE = 'MODE_IDLE';
export const MODE_2D_ZOOM_IN = 'MODE_2D_ZOOM_IN';
export const MODE_2D_ZOOM_OUT = 'MODE_2D_ZOOM_OUT';
export const MODE_2D_PAN = 'MODE_2D_PAN';
export const MODE_2D_PAN_READ_ONLY = 'MODE_2D_PAN_READ_ONLY';
export const MODE_3D_VIEW = 'MODE_3D_VIEW';
export const MODE_2D_SCREENSHOT = 'MODE_2D_SCREENSHOT';
export const MODE_3D_FIRST_PERSON = 'MODE_3D_FIRST_PERSON';
export const MODE_3D_VIEW_READ_ONLY = 'MODE_3D_VIEW_READ_ONLY';
export const MODE_3D_FIRST_PERSON_READ_ONLY = 'MODE_3D_FIRST_PERSON_READ_ONLY';
export const MODE_3D_SCREENSHOT = 'MODE_3D_SCREENSHOT';
export const MODE_WAITING_DRAWING_LINE = 'MODE_WAITING_DRAWING_LINE';
export const MODE_DRAGGING_LINE = 'MODE_DRAGGING_LINE';
export const MODE_DRAGGING_VERTEX = 'MODE_DRAGGING_VERTEX';
export const MODE_DRAGGING_VERTEX_TEST = 'MODE_DRAGGING_VERTEX_TEST';
export const MODE_DRAGGING_ITEM = 'MODE_DRAGGING_ITEM';
export const MODE_DRAGGING_AREA = 'MODE_DRAGGING_AREA';
export const MODE_DRAGGING_HOLE = 'MODE_DRAGGING_HOLE';
export const MODE_DRAWING_LINE = 'MODE_DRAWING_LINE';
export const MODE_DRAWING_HOLE = 'MODE_DRAWING_HOLE';
export const MODE_DRAWING_ITEM = 'MODE_DRAWING_ITEM';
export const MODE_ROTATING_ITEM = 'MODE_ROTATING_ITEM';
export const MODE_SCALING_ITEM = 'MODE_SCALING_ITEM';
export const MODE_ROTATING_LAYER = 'MODE_ROTATING_LAYER';
export const MODE_DRAGGING_LAYER = 'MODE_DRAGGING_LAYER';
export const MODE_UPLOADING_IMAGE = 'MODE_UPLOADING_IMAGE';
export const MODE_FITTING_IMAGE = 'MODE_FITTING_IMAGE';
export const MODE_VIEWING_CATALOG = 'MODE_VIEWING_CATALOG';
export const MODE_CONFIGURING_PROJECT = 'MODE_CONFIGURING_PROJECT';
export const MODE_MANAGING_LAYERS = 'MODE_MANAGING_LAYERS';
export const MODE_READ_ONLY = 'MODE_READ_ONLY';
export const MODE_ROTATING_AREA = 'MODE_ROTATING_AREA';

//MODALS
export const MODAL_TYPE_CONFIRM = 'MODAL_TYPE_CONFIRM';
export const MODAL_TYPE_ALERT = 'MODAL_TYPE_ALERT';

//Thinking about it...
//https://developer.mozilla.org/it/docs/Web/JavaScript/Reference/Global_Objects/Proxy
/*
let MODE_DEF = [
  'IDLE',
  '2D_ZOOM_IN',
  '2D_ZOOM_OUT',
  '2D_PAN',
  '3D_VIEW',
  '3D_FIRST_PERSON',
  'WAITING_DRAWING_LINE',
  'DRAGGING_LINE',
  'DRAGGING_VERTEX',
  'DRAGGING_ITEM',
  'DRAGGING_HOLE',
  'DRAWING_LINE',
  'DRAWING_HOLE',
  'DRAWING_ITEM',
  'ROTATING_ITEM',
  'UPLOADING_IMAGE',
  'FITTING_IMAGE',
  'VIEWING_CATALOG',
  'CONFIGURING_PROJECT',
];

export const MODE = new Proxy( MODE_DEF, { get: (target, name) => { return target.indexOf(name) !== -1 ? name : null } } );
*/

export const MODE_SNAPPING = [
  MODE_IDLE, MODE_2D_ZOOM_IN, MODE_2D_ZOOM_OUT, MODE_2D_PAN,
  MODE_WAITING_DRAWING_LINE, MODE_DRAWING_LINE, MODE_DRAWING_HOLE,
  MODE_DRAWING_ITEM, MODE_DRAGGING_LINE, MODE_DRAGGING_VERTEX,
  MODE_DRAGGING_ITEM, MODE_DRAGGING_HOLE, MODE_FITTING_IMAGE,
  MODE_UPLOADING_IMAGE, MODE_ROTATING_ITEM, MODE_SCALING_ITEM, MODE_MANAGING_LAYERS,
  MODE_ROTATING_LAYER, MODE_DRAGGING_LAYER, MODE_CONFIGURING_PROJECT
];

//UNITS
export const UNIT_MILLIMETER = 'mm';
export const UNIT_CENTIMETER = 'cm';
export const UNIT_METER = 'm';
export const UNIT_METER_SQUARE  = 'm2';
export const UNIT_INCH = 'in';
export const UNIT_FOOT = 'ft';
export const UNIT_FOOT_SQUARE  = 'ft2';
export const UNIT_MILE = 'mi';

export const CONVERT_METER_INCH = 'meter_inch';
export const CONVERT_INCH_METER = 'inch_meter';

export const UNITS_LENGTH = [
  UNIT_MILLIMETER,
  UNIT_CENTIMETER,
  UNIT_METER,
  UNIT_INCH,
  UNIT_FOOT,
  UNIT_MILE
];

// export const EPSILON = 1e-6;
export const EPSILON = 1e-9;

export const CATALOG_ROOT_NAME = 'root';

export const SAVE_TIMEOUT = 200;

export const UNIT_COEF = {
  [UNIT_MILLIMETER]: 0.1,
  [UNIT_CENTIMETER]: 1,
  [UNIT_METER]: 100,
  [UNIT_INCH]: 2.54,
  [UNIT_FOOT]: 30.48,
  [UNIT_MILE]: 160934.4,
};

export const PATTERN_COLOR = '#ffffff';
